import { ISimpleRepository } from "@/domain";

export class DeleteSimpleUseCase {
  constructor(
    private readonly SimpleRepository: ISimpleRepository
  ) {}

  async execute(table: string, id: string): Promise<void> {
    await this.SimpleRepository.delete(table,id);
  }
}